import * as React from 'react';
import { Tabs as Tablist } from '../Tabs/Tabs';
import { st, classes } from './TabbedContent.st.css';
import { TABBED_CONTENT_HOOKS } from './constants';
import { TabbedContentProps } from './types';

export const TabbedContent: React.FC<TabbedContentProps> = ({
  children,
  items,
  activeTabIndex,
  className,
  'data-hook': dataHook,
  ...props
}) => (
  <div className={classes.componentWrapper} data-hook={dataHook}>
    <Tablist
      className={st(classes.root, className)}
      items={items}
      activeTabIndex={activeTabIndex}
      {...props}
      isTablist
    />
    {items.map((item, idx) => (
      <div
        className={classes.contentWrapper}
        role="tabpanel"
        id={`${item.id}-tab`}
        key={item.id}
        hidden={idx !== activeTabIndex}
        aria-labelledby={item.id}
        data-hook={`${TABBED_CONTENT_HOOKS.contentContainer}-${idx}`}
      >
        {children(idx)}
      </div>
    ))}
  </div>
);

TabbedContent.displayName = 'TabbedContent';
